﻿import Vue from 'vue';
import moment from 'moment';

const applications = {
  state: {
    applications: [],
    submitted: [],
    approved: [],
    awarded: [],
    defaultApps: []
  },

  getters: {
    applications(state) {
      return state.applications;
    },
    submitted(state) {
      return state.submitted;
    },
    approved(state) {
      return state.approved;
    },
    awarded(state) {
      return state.awarded;
    },
    defaultApps(state) {
      return state.defaultApps;
    }
  },

  mutations: {
    getApplications(state, payload) {
      state.applications = payload;
    },
    getSubmitted(state, payload) {
      state.submitted = payload;
    },
    getApproved(state, payload) {
      state.approved = payload;
    },
    getAwarded(state, payload) {
      state.awarded = payload;
    },
    getDefault(state, payload){
      state.defaultApps = payload
    }
  },

  actions: {
    getApplications(context, payload) {
      const url = 'Applications';
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getApplications', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },
    getApplicationByID(context, payload) {
      const url =`Applications/${payload}`;
      return new Promise((resolve, reject) => {
        Vue.prototype.$axios
          .get(url)
          .then(
            (res) => {
              resolve(res)
            },
            (error) => {
              reject(error)
            },
          );
      })
    },
    getSubmitted(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Applications/AllSubmitted?lower=${moment(payload.lower).format('MM/DD/YYYY')}&upper=${moment(payload.upper).format('MM/DD/YYYY')}`;
        Vue.prototype.$axios
          .get(url)
          .then(
            (res) => {
              context.commit('getSubmitted', res.data);
              resolve(res)
            },
            (error) => {
              console.log(error);
              reject(error)
            },
          );

      })
    },
    getApproved(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Applications/AllApproved?lower=${moment(payload.lower).format('MM/DD/YYYY')}&upper=${moment(payload.upper).format('MM/DD/YYYY')}`;
        Vue.prototype.$axios
          .get(url)
          .then(
            (res) => {
              context.commit('getApproved', res.data);
              resolve(res)
            },
            (error) => {
              console.log(error);
              reject(error)
            },
          );
      })
    },
    getAwarded(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'Applications/AllAwarded';
        Vue.prototype.$axios
          .get(url)
          .then(
            (res) => {
              context.commit('getAwarded', res.data);
              resolve(res)
            },
            (error) => {
              console.log(error);
              reject(error)
            },
          );
      })
    },
    getDefault(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Applications/AppsInDefault?lower=${moment(payload.lower).format('MM/DD/YYYY')}&upper=${moment(payload.upper).format('MM/DD/YYYY')}`;
        Vue.prototype.$axios
          .get(url)
          .then(
            (res) => {
              context.commit('getDefault', res.data);
              resolve(res)
            },
            (error) => {
              console.log(error);
              reject(error)
            },
          );
      })
    },
    updateApplications(context, payload){
      const url = `Applications/${ payload.Id }`;
      Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('getApplications')
          },
          (error) => {
            console.log(error);
          },
        );
    },
    createApplications(context, payload){
      const url = `Applications`;
      Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.dispatch('getApplications')
          },
          (error) => {
            console.log(error);
          },
        );
    },
    deleteApplications(context, payload){
      const url = `Applications/${ payload.Id }`;
      Vue.prototype.$axios
        .delete(url)
        .then(
          (res) => {
            context.dispatch('getApplications')
          },
          (error) => {
            console.log(error);
          },
        );
    }
  },
}

export default applications